import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { UserList, PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { LanguageService, ApiOrganizationsService, FilesService } from 'src/app/services';

@Component({
  selector: 'app-org-user-profile',
  templateUrl: './org-user-profile.component.html',
  styleUrls: ['./org-user-profile.component.css']
})
export class OrgUserProfileComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  profileData: any;
  employeeId: string;
  employees: UserList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  noLogoLetter:string;

  
  @Input() set data(value) {

    if (value != null) {
      console.log("VALUE: ", value);
      
      this.employeeId = value.employee_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private currentRoute: ActivatedRoute,
    private fileService: FilesService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.onInfo();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  onInfo(): void {

    this.progressRef.start();
    this.loading = true;
    this.profileData = null;

    this.apiOrganizations.employeeInfo(this.employeeId).subscribe((response: Res) => {
      console.log("EMPLOYEE: ", response);
      

      if (response != null) {

        this.profileData = response.result;

        this.noLogoLetter = this.profileData.fullname.substring(0, 1);
      
        this.getImageContent(response.result);
     
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   * @param product Product
   */
   getImageContent(profileData: any): void {
      
    if (profileData.avatar_pic && profileData.avatar_pic != null) {

      this.subscriptions.add(
        this.fileService.getImageContent(profileData.avatar_pic).subscribe((response: any) => {

          if (response != null) {

            profileData['avatar_pic'] = response.result;

          }
        })
      );
    }
  }


}
